import { focusStyles, popoverStyles, sideMenuLinkStyles, sideMenuWrapperStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        buttonProps: {
            css: css`
                ${focusStyles()}
                background: transparent;
                border-radius: 0;
                min-width: 0;
                &:hover,
                &:active,
                &:focus {
                    background: transparent;
                    border-color: transparent;
                }
            `,
        },
        cssOverrides: {
            menu: css`
                ${sideMenuWrapperStyles()}
                ${popoverStyles()}
            `,
            menuItem: css`
                &:hover,
                &:active,
                &:focus {
                    background: transparent;
                    color: inherit;
                }
                ${sideMenuLinkStyles()}
            `,
        },
    },
};
